import { Theme, Typography } from '@mui/material'
import Stack from '@mui/material/Stack'
import React from 'react'

const SX = {
  fontWeight: 'bold',
  color: (theme: Theme) => theme.palette.grey[600],
}
export const PrivacyModalComponent: React.FC = () => (
  <Stack flexDirection="column" gap={1} padding={2}>
    <Typography variant="body1" paragraph>
      JustLockIt Self Storage, its affiliates, successors and assigns
      (“JustLockIt”) provide its services to you subject to the following
      notices, terms, and conditions, which JustLockIt may amend in its sole
      discretion from time to time without notice.
    </Typography>
    <Typography variant="h5" sx={SX}>
      Promotions and Offers
    </Typography>
    <Typography variant="body1" paragraph>
      Subject to change. Promotions good for new customers only. Subject to
      specific units and availability. Other restrictions, taxes, fees, and
      administrative fee, apply. See Rental Agreement for full details. Not
      available on transfers or additional spaces. Pricing subject to change.
      Reservation required to guarantee price. Actual unit sizes may vary from
      approximate size estimate. Please inspect any unit before renting. Online
      pricing available only for online reservations and rentals.
    </Typography>
    <Typography variant="h5" sx={SX}>
      Refunds
    </Typography>
    <Typography variant="body1" paragraph>
      All rental transactions are final. If you rent a storage unit/space, you
      are not entitled to a refund for any unused portion of the rental period
      for which you have paid, including prepaid rent. The Term of the Rental
      Agreement shall commence on the date the Rental Agreement is executed and
      shall continue on a month-to-month basis thereafter. The minimum term is
      one month. Manager does not prorate or refund partial month’s rent. Tenant
      covenants with JustLockIt that at the expiration of the term of the Rental
      Agreement, peaceable possession of the storage unit shall be given to
      JustLockIt, in as good condition as it is now, normal wear and tear
      excepted. If Tenant fails or refuses to remove Tenant's personal property
      after the term expires, JustLockIt may determine, in its sole discretion
      that the term has automatically renewed for an additional month.
    </Typography>
    <Typography variant="h5" sx={SX}>
      Privacy Policy
    </Typography>
    <Typography variant="body1" paragraph>
      JustLockIt respects the privacy of its users. We may collect personally
      identifiable information when you visit our website, but we will not sell
      any personally identifiable information to anyone.
    </Typography>
    <Typography variant="h5" sx={SX}>
      Disclaimer
    </Typography>
    <Typography variant="body1" paragraph>
      This website is provided by JustLockIt on an "as is" basis. JustLockIt
      makes no representations or warranties of any kind, express or implied, as
      to the operation of the site or the information, content, materials, or
      products included on this site. JustLockIt disclaims all warranties,
      express or implied, including, but not limited to, implied warranties of
      merchantability and fitness for a particular purpose. JustLockIt will not
      be liable for any damages of any kind arising from the use of this site,
      including, but not limited to direct, indirect, incidental, punitive, and
      consequential damages.
    </Typography>
    <Typography variant="h5" sx={SX}>
      Indemnification
    </Typography>
    <Typography variant="body1" paragraph>
      Tenant agrees to indemnify, hold harmless and defend JustLockIt from any
      and all claims, damages, fines, judgments, penalties, costs, liabilities
      or losses, and any and all sums paid for settlement of claims, attorney's
      fees, consultant and expert fees, arising out of your use of the website
      and services, including but not limited to out of your violation of any
      representation or warranty contained in these Terms and Conditions.
    </Typography>
  </Stack>
)
